export default __webpack_public_path__ + "82926d23ba41f6b13108ba25ac301e47.png";